import { render } from "./ArchivedUsersDataTable.vue?vue&type=template&id=27321d96"
import script from "./ArchivedUsersDataTable.vue?vue&type=script&lang=js"
export * from "./ArchivedUsersDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__